import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder } from "@angular/forms";
import { FormHelperService } from "../../../services/form-helper.service";
import { ToastService } from "../../../services/toast.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ReferentielService } from "../../../services/referentiel.service";
import { BackResourceService } from "../../../services/back-resource.service";
import { Logement } from "../../../models/logement";
import { faCloudUploadAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { combineLatest, Observable } from "rxjs";
import { LogementService } from "../../../services/logement.service";
import { LoaderService } from "../../../services/loader.service";
import { Image } from "../../../models/image";
import {Location} from '@angular/common';

@Component({
    selector: 'app-logement-edit',
    templateUrl: './logement-edit.component.html',
    styleUrls: ['./logement-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogementEditComponent implements OnInit {

  faTrash = faTrash;
  faCloudUploadAlt = faCloudUploadAlt;

  logementId: number = null;

  logement: Logement = null;

  referentiels: any = null;

  image = new Image();

  form = this.fb.group({
    nom: [],
    numeroFiscal: [],
    typeLogement: [],
    typeLogementPersonnalisee: '',
    adresse: [],
    deletePhoto: [false]
  });

  @ViewChild('adresseComponent')
  adresseComponent;

  constructor(
    private logementService: LogementService,
    private referentielService: ReferentielService,
    private fb: UntypedFormBuilder,
    private fh: FormHelperService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private backResource: BackResourceService,
    public loaderService: LoaderService,
    private _location: Location
  ) {
  }

  ngOnInit() {
    this.logementId = parseInt(this.route.snapshot.paramMap.get('id'));
    if (this.logementId) {
      this.logementService.findById(this.logementId).then(logement => {
        this.image = new Image(logement.photo && logement.photo.url ? (this.backResource.getUrl(logement.photo.url)) : null)
        this.logement = logement;
        this.form.patchValue(logement);
      });
    }
    this.loadReferentiels();
  }

  backClicked() {
    this._location.back();
  }

  private loadReferentiels() {
    this.referentielService.all().then((referentiels) => {
      this.referentiels = referentiels;
    });
  }

  save() {
    const logment = this.form.getRawValue();
    logment.photo = {binaryContent: this.image.current === this.image.original ? null : this.image.file};
    this.logementService.save(this.logementId, logment).then((response) => {
      this.toastService.show(response.message, {classname: 'toast-' + response.status});

      if (response.status == 'error') {
        this.fh.setSymfonyFormErrors(this.form, response.errors, true);
        this.fh.setSymfonyFormErrors(this.adresseComponent.form, response.errors.adresse, true);
      } else {
        const logementCourant$ = this.logementService.load();
        const logementCouranteId$ = this.logementId ? this.logementService.reloadLogementCourant() : this.logementService.setLogementCourantId(response.id);
        combineLatest([logementCourant$, logementCouranteId$]).toPromise().then(() => {
          this.router.navigate([this.logementId ? '/mes-logements' : '/accueil']);
        });
      }
    });
  }

  updatePhoto(event) {
    const that = this;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      this.image.file = event.target.files[0];
      this.form.get('deletePhoto').setValue(false);
      reader.onload = (e) => {
        that.image.current = e.target.result as string;
      };
      reader.readAsDataURL(this.image.file);
    }
  }

  deletePhoto() {
    this.image.current = null;
    this.form.get('deletePhoto').setValue(true);
  }

  get nom() {
    return this.form.get('nom').value
  }

  get localite() {
    const adresse = this.form.get('adresse').value;
    if (adresse == null) {
      return null;
    }
    return adresse.codePostal + ' ' + adresse.nomCommune;
  }

  get hasLogement(): Observable<boolean> {
    return this.logementService.hasLogement();
  }
}
